import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import dayjs from "dayjs";

export interface ILocation {
  LocationId: number | null;
  Id: number | null;
  Location: String | null;
  Cost: number | null;
}

export interface ICost {
  Id: number | null;
  OrderId: number | null;
  SeminarOrderItemId: number | null;
  EventId: number | null;
  CostId: number | null;
  CostName: string | null;
  Cost: number | null;
  EventCostVarId: number | null;
}

export interface IVideoCost {
  Id: number | null;
  CostName: string | null;
  Cost: number | 0;
}

export interface IMembership {
  EventType: string | null;
  Id: number | null;
  SectionName: string | null;
  Fee: number | null;
}

export interface ISection {
  Fee: number;
  Id: number;
  SectionDescription: string;
  SectionName: string;
  isSelected: boolean;
}

export interface IMemberOrder {
  OrderId: number;
  MemberId: number;
  EffectiveFiscalYearDateStart: string | null;
  MemberCode: string;
  Description: string;
  TotalAmount: number;
  AmountPaid: number;
  DueAmount: number;
  OrderStatus: number;
  CurrentYearSections: (number | null)[] | [] | undefined;
  SectionNames: string;
  InvoiceId: number;
  InvoiceUrl: string;
}

export interface IOrderItem {
  // Id: number | null;
  OrderItemId: number | null;
  EventId: string | null | number;
  MemberCodeId: number | null;
  EventName: string;
  Location: ILocation | null;
  Costs: ICost[] | null;
  VideoCost: IVideoCost[] | null;
  OrderType: string | null;
  IsAttended: number | null;
  IsAttendenceUpdated: number | null;
  Description: string;
  UniqueEventId: string;
  StartDateTime: string | null;
  EndDateTime: string | null;
  CostVariationTotalCost: number | null;
  EventVariationTotalCost: number | null;
  MemberCode: string | null;
  MemberCodeFee: number | null;
  isAddSection:boolean | false
  ProratedDues: number | null;
  IncludeNextYear: boolean | false;
  MemberCodeDesc: string | null;
  EventType: string | null;
  ParticipantType: string | null;
  LastYearSections: number[] | [];
  // CurrentYearSections: number[] | [];
  CurrentYearSections: (number | null)[] | [] | undefined;
  membershipItemList: IMembership[] | [];
  // VideoCost: number | null;
}

export interface IOrder {
  MemberId: number | null;
  OrderId: number | null;
  TotalAmount: number;
  AmountPaid: number;
  DueAmount: number;
  CouponAmount: number;
  IsAddSection: boolean | false;
  TransactionType: string | null; // this is Transaction Type
  DatePaid: string | null;
  CheckNumber: string | null;
  LateFee: number | null;
  AuthCode: string | null;
  Comments: string | null;
  NoInvoice: boolean | null;
  Orders: IOrderItem[] | [];
  SeminarOrder: IOrderItem[] | [];
  CurrentOrderId: number | null;
  HasSeminarOrderItem: boolean;
  HasFunctionOrderItem: boolean;
  HasMembershipOrderItem: boolean;
  HasSectionOrderItem: boolean;
  HasVideoOrderItem: boolean;
  Sections: ISection[];
  enrollmentStartDate: string;
  enrollmentEndDate: string;
  CurrentPage: number;
  searchElement: string;
  SortBy: string;
  SortType: string;
  Paginate: number;
  OrderType: string;
}

export const initalOrderItem: IOrderItem = {
  // Id: null,
  OrderItemId: null,
  EventId: "0",
  MemberCodeId: null,
  EventName: "",
  Location: null,
  Costs: [],
  VideoCost: [],
  OrderType: "",
  IsAttended: null,
  IsAttendenceUpdated: null,
  Description: "",
  UniqueEventId: "",
  StartDateTime: "",
  EndDateTime: "",
  CostVariationTotalCost: null,
  EventVariationTotalCost: null,
  MemberCode: "",
  MemberCodeFee: null,
  MemberCodeDesc: "",
  EventType: "",
  ParticipantType: "Attendee",
  LastYearSections: [],
  CurrentYearSections: [],
  ProratedDues: null,
  membershipItemList: [],
  IncludeNextYear: false,
  isAddSection: false,
  // VideoCost: 0,
};

const initialState: IOrder = {
  MemberId: 0,
  OrderId: null,
  TotalAmount: 0,
  AmountPaid: 0,
  DueAmount: 0,
  CouponAmount: 0,
  IsAddSection: false,
  TransactionType: null, // this is Transaction Type
  DatePaid: dayjs().format("YYYY-MM-DD"),
  CheckNumber: "",
  LateFee: 0,
  AuthCode: "",
  Comments: "",
  NoInvoice: false,
  Orders: [initalOrderItem],
  SeminarOrder: [],
  CurrentOrderId: null,
  HasSeminarOrderItem: false,
  HasFunctionOrderItem: false,
  HasMembershipOrderItem: false,
  HasSectionOrderItem: false,
  HasVideoOrderItem: false,
  Sections: [],
  enrollmentStartDate: "",
  enrollmentEndDate: "",
  CurrentPage: 1,
  searchElement: "",
  SortBy: "DatePaid",
  SortType: "Desc",
  Paginate: 10,
  OrderType: "",
};

type BodyType = {
  key: string;
  value: string | number | boolean | ISection[] | ILocation | null | IOrderItem;
};

type OrderItemBody = {
  key: string;
  value: IOrderItem;
};

type OrderItemCostsBody = {
  key: string;
  value: ICost;
};

type OrderItemVideoCostsBody = {
  key: string;
  value: IVideoCost;
};

type SectionItemBody = {
  key: string;
  value: ISection;
};

// // Action Types
// const FILTER_ITEMS = "storeUpdateVideoItem";

// // Action Creators
// export const filterItems = (
//   condition: (item: IOrderItem) => boolean,
//   payload: IOrderItem[]
// ) => ({
//   type: FILTER_ITEMS,
//   condition,
//   payload,
// });

export const orderApiSlice = createSlice({
  name: "orderapislice",
  initialState,
  reducers: {
    storeResetOrder: () => {
      console.log("storeResetOrder called");
      return initialState;
    },
    assignOrderInfo: (state: any, action) => {
      console.log("assignOrderInfo:", action.payload);
      return action.payload;
    },
    storeUpdateOrder: (state: any, action: PayloadAction<BodyType>) => {
      console.log(
        "key&value-storeUpdateOrder:",
        action.payload.key,
        ":",
        action.payload.value
      );
      // state[action.payload.key] = action.payload.value;1
      const newState = {
        ...state,
        [action.payload.key]: action.payload.value,
      };
      return newState;
    },

    storeAddOrderItem: (state: any, action: PayloadAction<OrderItemBody>) => {
      console.log(
        "key&value-storeAddOrderItem:",
        action.payload.key,
        ":",
        action.payload.value
      );

      const newState = {
        ...state,
        [action.payload.key]: [
          ...state[action.payload.key],
          action.payload.value,
        ],
      };
      return newState;
    },

    // In this function, we are adding memberCode and section purchase.
    storeUpdateSectionOrderItem: (
      state: any,
      action: PayloadAction<OrderItemBody>
    ) => {
      console.log(
        "key&value-storeUpdateSection&MemberCodeOrderItem:",
        action.payload.key,
        ":",
        action.payload.value
      );
      const { key, value } = action.payload;

      // Find the index of the item to be updated
      const indexToUpdate = state[key].findIndex(
        (currentOrderItem: IOrderItem) =>
          currentOrderItem.EventType === "Membership"
      );

      console.log("INDEX:", indexToUpdate);

      if (indexToUpdate !== -1 && value.membershipItemList.length > 0) {
        const updatedOrderItems = [...state[key]];

        updatedOrderItems[indexToUpdate] = {
          ...updatedOrderItems[indexToUpdate],
          CurrentYearSections: value.CurrentYearSections,
          membershipItemList: value.membershipItemList,
        };

        const newState = {
          ...state,
          [key]: updatedOrderItems,
        };
        console.log("new state0:", newState);
        return newState;
      } else if (
        indexToUpdate !== -1 &&
        value.membershipItemList.length === 0
      ) {
        // order item object doesn't exist
        const updatedOrderItems = [...state[key]];

        updatedOrderItems[indexToUpdate] = {
          ...updatedOrderItems[indexToUpdate],
          MemberCodeId: value.MemberCodeId,
          MemberCode: value.MemberCode,
          MemberCodeFee: value.MemberCodeFee,
          MemberCodeDesc: value.MemberCodeDesc,
        };

        const newState = {
          ...state,
          [key]: updatedOrderItems,
        };
        console.log("new state1:", newState);
        return newState;
      } else if (indexToUpdate === -1) {
        // order item object doesn't exist
        const newState = {
          ...state,
          [action.payload.key]: [
            ...state[action.payload.key],
            action.payload.value,
          ],
        };
        console.log("new state2:", newState);
        return newState;
      }

      return state;
    },

    // we are storeing section obejct in store with isSelected flag
    // to track and compute cost quickly. it is not stored in database.
    storeUpdateSectionItem: (
      state: any,
      action: PayloadAction<SectionItemBody>
    ) => {
      console.log(
        "key&value-storeUpdateSectionItem:",
        action.payload.key,
        ":",
        action.payload.value
      );
      const { key, value } = action.payload;

      // Find the index of the item to be updated
      const indexToUpdate = state[key].findIndex(
        (sectionItem: ISection) => sectionItem.Id === value.Id
      );

      console.log("INDEX:", indexToUpdate);

      if (indexToUpdate !== -1) {
        const updatedSectionItems = [...state[key]];
        updatedSectionItems[indexToUpdate] = value;

        const newState = {
          ...state,
          [key]: updatedSectionItems,
        };
        return newState;
      } else {
        const newState = {
          ...state,
          [action.payload.key]: [
            ...state[action.payload.key],
            action.payload.value,
          ],
        };
        return newState;
      }

      return state;
    },

    storeUpdateVideoItem: (
      state: any,
      action: PayloadAction<{
        condition: (item: IOrderItem) => boolean;
        payload: IOrderItem[];
      }>
    ) => {
      const filteredOrders = state.Orders.filter(
        (orderItem: IOrderItem) => !action.payload.condition(orderItem) // Remove items that match the condition
      );
      const newState = {
        ...state,
        Orders: [...filteredOrders, ...action.payload.payload], // Concatenate the filtered items with the new payload
      };
      return newState;
    },

    storeAssignOrderItem: (
      state: any,
      action: PayloadAction<OrderItemBody>
    ) => {
      console.log(
        "key&value-storeUpdateOrderItem:",
        action.payload.key,
        ":",
        action.payload.value
      );
      const { key, value } = action.payload;
      const newState = {
        ...state,
        [action.payload.key]: [action.payload.value],
      };
      console.log("checking OrderItemID:", newState.Orders);
      return newState;
    },

    storeUpdateOrderItem: (state: any, action: PayloadAction<BodyType>) => {
      console.log(
        "key&value-storeUpdateOrderItem:",
        action.payload.key,
        ":",
        action.payload.value
      );
      const { key, value } = action.payload;

      const updatedOrders = {
        ...state,
        Orders: [
          {
            ...state.Orders[0],
            [action.payload.key]: action.payload.value,
          },
        ],
      };

      return updatedOrders;
    },

    storeUpdateOrderItem1: (state: any, action: PayloadAction<BodyType>) => {
      console.log(
        "key&value-storeUpdateOrderItem1:",
        action.payload.key,
        ":",
        action.payload.value
      );

      const { key, value } = action.payload;

      if (state.Orders && state.Orders.length > 0) {
        state.Orders[0] = value; // Mutating Orders[0] in place
      } else {
        console.warn("Orders array is empty or undefined.");
      }
    },

    storeAddOrderItemCosts: (
      state: any,
      action: PayloadAction<OrderItemCostsBody>
    ) => {
      const { value } = action.payload;

      // If Orders array is initially empty, create a new order item with the new cost
      if (state.Orders.length === 0) {
        return {
          ...state,
          Orders: [{ ...initalOrderItem, Costs: [value] }],
        };
      }

      console.log("value-storeAddOrderItemCosts:", action.payload.value);
      // Copy the existing order item array
      const updatedOrders = {
        ...state,
        Orders: state.Orders.map((orderItem: IOrderItem) => ({
          ...orderItem,
          Costs: [...(orderItem.Costs || []), value], // Append the new cost object to the Costs array
        })),
      };
      console.log("updatedOrders", updatedOrders);
      return updatedOrders;
    },

    storeRemoveOrderItemCosts: (
      state: any,
      action: PayloadAction<OrderItemCostsBody>
    ) => {
      const { value } = action.payload;

      const index = state.Orders[0].Costs.findIndex(
        (cost: ICost) => (cost.CostId == undefined) ? cost.EventCostVarId === value.CostId : cost.CostId === value.CostId
      );

      // If the index is valid (i.e., cost object exists in the array)
      if (index !== -1) {
        // Create a new array with the cost object removed
        const updatedCosts = [
          ...state.Orders[0].Costs.slice(0, index),
          ...state.Orders[0].Costs.slice(index + 1),
        ];

        const updatedOrders = {
          ...state,
          Orders: [
            {
              ...state.Orders[0],
              Costs: updatedCosts,
            },
          ],
        };

        console.log("updatedOrders", updatedOrders);
        return updatedOrders;
      }

      // Copy the existing order item array
      // const updatedOrders = {
      //   ...state,
      //   Orders: (state.Orders[0] = {
      //     ...state.Orders[0],
      //     Costs: [...state.Orders[0].Costs.slice(0, index)],
      //   }),
      // };
      return state;
    },

    storeAddOrderItemVideoCost: (
      state: any,
      action: PayloadAction<OrderItemVideoCostsBody>
    ) => {
      const { value } = action.payload;

      // If Orders array is initially empty, create a new order item with the new cost
      if (state.Orders.length === 0) {
        return {
          ...state,
          Orders: [{ ...initalOrderItem, VideoCost: [value] }],
        };
      }

      console.log("value-storeAddOrderItemVideoCosts:", action.payload.value);
      // Copy the existing order item array
      const updatedOrders = {
        ...state,
        Orders: state.Orders.map((orderItem: IOrderItem) => ({
          ...orderItem,
          // VideoCost: [...(orderItem.VideoCost || []), value], // Append the new cost object to the Costs array
          VideoCost: [value], // Append the new cost object to the Costs array
        })),
      };
      console.log("updatedOrders", updatedOrders);
      return updatedOrders;
    },

    storeRemoveOrderItemVideoCost: (
      state: any,
      action: PayloadAction<OrderItemVideoCostsBody>
    ) => {
      const { value } = action.payload;

      // const index = state.Orders[0].VideoCost.findIndex(
      //   (videoCost: IVideoCost) => videoCost.CostName === value.CostName
      // );

      // // If the index is valid (i.e., cost object exists in the array)
      // if (index !== -1) {
      //   // Create a new array with the cost object removed
      //   const updatedVideoCosts = [
      //     ...state.Orders[0].VideoCost.slice(0, index),
      //     ...state.Orders[0].ViodeCost.slice(index + 1),
      //   ];

      const updatedOrders = {
        ...state,
        Orders: [
          {
            ...state.Orders[0],
            VideoCost: [],
          },
        ],
      };

      console.log("updatedOrders", updatedOrders);
      return updatedOrders;
      // }

      // Copy the existing order item array
      // const updatedOrders = {
      //   ...state,
      //   Orders: (state.Orders[0] = {
      //     ...state.Orders[0],
      //     Costs: [...state.Orders[0].Costs.slice(0, index)],
      //   }),
      // };
      // return state;
    },

    resetOrderParameters: () => {
      console.log("order slice reset store called");
      return initialState;
    },

    setCurrentOrderId: (state: any, action: PayloadAction<number>) => {
      state.CurrentOrderId = action.payload;
    },
    setOrderCurrentPage: (state: any, action: PayloadAction<number>) => {
      state.CurrentPage = action.payload;
    },
    setSearchElement: (state: any, action: PayloadAction<string>) => {
      state.searchElement = action.payload;
    },
    setUpdateSortType: (state: any, action: PayloadAction<string>) => {
      state.SortType = action.payload;
    },
    setUpdateSortBy: (state: any, action: PayloadAction<string>) => {
      state.SortBy = action.payload;
    },
    setOrderPaginate: (state: any, action: PayloadAction<number>) => {
      state.Paginate = action.payload;
    },
    setOrderType: (state: any, action: PayloadAction<string>) => {
      state.OrderType = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  assignOrderInfo,
  storeResetOrder,
  storeUpdateOrder,
  storeAddOrderItem,
  storeAddOrderItemCosts,
  storeRemoveOrderItemCosts,
  storeAddOrderItemVideoCost,
  storeRemoveOrderItemVideoCost,
  resetOrderParameters,
  setCurrentOrderId,
  storeUpdateSectionItem,
  storeUpdateVideoItem,
  storeUpdateSectionOrderItem,
  setOrderCurrentPage,
  setSearchElement,
  setUpdateSortType,
  setUpdateSortBy,
  setOrderPaginate,
  storeAssignOrderItem,
  storeUpdateOrderItem,
  storeUpdateOrderItem1,
  setOrderType,
} = orderApiSlice.actions;

export default orderApiSlice.reducer;
